module.exports = __webpack_public_path__ + "static/product2-78d87963f6df84d2906334d5486c9997.png";